import { render } from "./App.vue?vue&type=template&id=4ef43354"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4ef43354&lang=css"
script.render = render

export default script